/**
 * All strings with TEMPLATE suffix will be replaced by nginx with proper env variables.
 */
export const B2C_TENANT_NAME = process.env.REACT_APP_B2C_TENANT_NAME ?? '';
export const B2C_CLIENT_ID = process.env.REACT_APP_B2C_CLIENTID ?? '';
export const B2C_TENANT_URL = `https://${B2C_TENANT_NAME}.b2clogin.com/${B2C_TENANT_NAME}.onmicrosoft.com`;
export const b2cPolicies = {
    names: {
        login: 'B2C_1_SignupSignin',
        signup: 'B2C_1_SignUp',
        passwordReset: 'B2C_1_PasswordReset',
    },
    authorities: {
        SignupSignin: {
            scopes: [],
            authority: `${B2C_TENANT_URL}/b2c_1_signupsignin`,
        },
        Signup: {
            scopes: [],
            authority: `${B2C_TENANT_URL}/b2c_1_signup`,
        },
        PasswordReset: {
            scopes: [],
            authority: `${B2C_TENANT_URL}/b2c_1_passwordreset`,
        },
    },
};
export const loginRequest = {
    // openId, profile and offline_access scopes provided by default
    scopes: [],
};
export const tokenRequest = {
    scopes: [`https://${B2C_TENANT_NAME}.onmicrosoft.com/api/apiAccess`],
};
